interface VoiceInputButtonProps {
  isListening: boolean;
  isSupported: boolean;
  onToggle: () => void;
}

const VoiceInputButton = ({ isListening, isSupported, onToggle }: VoiceInputButtonProps) => {
  if (!isSupported) return null;

  return (
    <button
      type="button"
      onClick={onToggle}
      className={`p-2 rounded-lg transition-all duration-200 flex-shrink-0 ${
        isListening ? 'voice-pulse text-red-500' : ''
      }`}
      style={!isListening ? { color: 'var(--text-secondary)' } : undefined}
      aria-label={isListening ? 'Stop listening' : 'Start voice input'}
      title={isListening ? 'Stop listening' : 'Voice input'}
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z" />
      </svg>
    </button>
  );
};

export default VoiceInputButton;
